export const getallonboarddetails=`
query GetAllOnboards(
  $page: Int
  $pageSize: Int
) {
  getAllOnboards (
    page: $page
    pageSize: $pageSize
  ) {
    success
    error
    message
    totalCount
    currentPage
    totalPages
    hasNextPage
    hasPreviousPage
    screening {
      id
      candidateName
      candidateNumber
      onboardDate
      shortlistedDate
      interviewDate
      joiningDate
      position{
        id
        positionName
      }
      client{
        id
        clientName
 
      }
      status
      shortlistFeedback
      interviewFeedback
      onboardedFeedback
      srDate
      date
      createdBy
      createdAt
      updatedAt
      updatedBy
      onboardDate
    }
  }
}
`

export const getallFilteronboarddetails=`
query GetAllOnboards(
  $hrUserId: ID
  $page: Int
  $pageSize: Int
) {
  getAllOnboards(
    hrUserId: $hrUserId
    page: $page
    pageSize: $pageSize
  ) {
    success
    error
    message
    totalCount
    currentPage
    totalPages
    hasNextPage
    hasPreviousPage
    screening {
      id
      candidateName
      candidateNumber
      shortlistedDate
      interviewDate
      onboardDate
      position{
        id
        positionName
      }
      client{
        id
        clientName
      }
      status
      shortlistFeedback
      interviewFeedback
      onboardedFeedback
      srDate
      date
      createdBy
      createdAt
      updatedAt
      updatedBy
      onboardDate
    }
  }
}
`


export const searchOnboard = `query SearchOnboardCandidates(
  $search: String!,
  $page: Int!,
  $pageSize: Int!,
  $hrUserId: ID
) {
  searchOnboardCandidates(
    search: $search,
    page: $page,
    pageSize: $pageSize,
    hrUserId: $hrUserId
  ) {
    success
    totalCount
    currentPage
    totalPages
    hasNextPage
    hasPreviousPage
 
    screening {
      id
      candidateName
      onboardDate
      candidateNumber
      shortlistedDate
      interviewDate
 
      position {
        id
        positionName
      }
 
      client {
        id
        clientName
      }
 
      status
      shortlistFeedback
      interviewFeedback
      onboardedFeedback
      srDate
      date
      createdBy
      createdAt
      updatedAt
      updatedBy
    }
  }
}
 `